import { html } from "htm/preact/index.js";

/**
 * @typedef {object} SvgIconProps
 * @property {string} icon
 * @property {string} [classes]
 */
function SvgIcon({ classes, icon }) {
  return html`
    <svg
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      class=${classes}
    >
      <use href=${icon}></use>
    </svg>
  `;
}

export default SvgIcon;
